import { SvgIcon } from "@mui/material"

export function FilterCheckboxIcon() {
  return (
    <SvgIcon>
      <path d="M 16.548484,1.6764302 21.665,1.665 21.645582,21.652593 c 0,0 -2.267004,0.02494 -4.881782,0.0041 l -0.215316,0.005 H 6.6261706 c -2.6561217,-1.55e-4 -4.9561958,-0.0084 -4.9561958,-0.0084 l -0.00496,-4.988179 V 6.6720033 c -4.214e-4,-2.9842274 0.00906,-4.918338 0.00906,-4.918338 L 16.548484,1.6754308 Z M 3.1654659,3.1754019 c 0,0 -0.012105,1.7896333 -0.012105,3.9972579 V 20.177197 c 0,0 1.7769484,-0.01345 3.9689255,-0.01345 H 20.014043 c 0,0 0.0072,-1.789633 0.0072,-3.997258 V 3.1631452 c -4.299594,0.018855 -21.1554491,0.012257 -16.8557771,0.012257 z" />
    </SvgIcon>
  )
}

export function FilterCheckboxCheckedIcon() {
  return (
    <SvgIcon>
      <path d="m 16.650337,1.665 c 2.758724,0 4.995112,0.00913 4.995112,0.00913 L 21.665,21.62587 c 2e-6,3e-6 -2.255939,0.02869 -5.014663,0.02869 H 6.6601123 C 3.901388,21.654565 1.665,21.665 1.665,21.665 V 6.6623911 C 1.665,3.9024083 1.6936775,1.665 1.6936775,1.665 Z M 15.026925,8.9162145 10.900963,13.04406 9.1526733,11.294973 c -0.3430279,-0.339945 -0.8957599,-0.339945 -1.2387878,0 -0.3396677,0.339822 -0.3396677,0.889535 0,1.239353 l 2.3776735,2.368763 c 0.169834,0.169911 0.389619,0.24987 0.609404,0.24987 0.229775,0 0.44956,-0.07996 0.619393,-0.24987 l 4.745357,-4.747522 c 0.339668,-0.3398221 0.339668,-0.8895351 0,-1.2393525 -0.343028,-0.339945 -0.895759,-0.339945 -1.238788,0 z" />
    </SvgIcon>
  )
}
